var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel wraper panel-gray" },
    [
      _c("div", { staticClass: "panel-header" }, [
        _c("div", { staticClass: "panel-title" }, [_vm._v(_vm._s(_vm.lbl))])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "panel-body", attrs: { id: "formbody" } },
        [
          _c(
            "q-field",
            {
              attrs: {
                error: _vm.$v.tempHospital.abbr.$error,
                "error-label": _vm._f("errorLabel")(_vm.$v.tempHospital.abbr)
              }
            },
            [
              _c("q-input", {
                attrs: { autofocus: true, "float-label": "Назв.сокр-ное" },
                model: {
                  value: _vm.tempHospital.abbr,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.tempHospital,
                      "abbr",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "tempHospital.abbr"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "q-field",
            [
              _c("q-input", {
                attrs: { "float-label": "Название" },
                model: {
                  value: _vm.tempHospital.fullName,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.tempHospital,
                      "fullName",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "tempHospital.fullName"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "q-field",
            {
              attrs: {
                error: _vm.$v.tempHospital.city.$error,
                "error-label": _vm._f("errorLabel")(_vm.$v.tempHospital.city)
              }
            },
            [
              _c(
                "q-input",
                {
                  attrs: { "float-label": "Город" },
                  model: {
                    value: _vm.tempHospital.city,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.tempHospital,
                        "city",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "tempHospital.city"
                  }
                },
                [
                  _c("q-autocomplete", {
                    attrs: {
                      "static-data": { field: "value", list: _vm.cities }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "q-field",
            [
              _c("q-input", {
                attrs: { "float-label": "Адрес" },
                model: {
                  value: _vm.tempHospital.address,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.tempHospital,
                      "address",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "tempHospital.address"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "q-field",
            [
              _c("q-input", {
                attrs: { type: "textarea", rows: 1, "float-label": "Контакты" },
                model: {
                  value: _vm.telString,
                  callback: function($$v) {
                    _vm.telString = typeof $$v === "string" ? $$v.trim() : $$v
                  },
                  expression: "telString"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "q-field",
            [
              _c("q-input", {
                attrs: { type: "textarea", rows: 1, "float-label": "Заметки" },
                model: {
                  value: _vm.tempHospital.comment,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.tempHospital,
                      "comment",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "tempHospital.comment"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("save-btn", {
        attrs: {
          notChanged: _vm.notChanged,
          goView: _vm.goView,
          doSave: _vm.doSave
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fd162506", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd162506","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/hospital-edit.vue
// module id = null
// module chunks = 